/**
 * 帳票の下書き削除の窓（#266 の直し、docs/96 §13.5）。見積書の「下書き削除」（Estimate.tsx の askDelete）と同じ形＝
 *   .dim ＞ .dlg[role=alertdialog]・題「下書き削除」・主は「取消」（はじめのフォーカス）・「削除」は朱・Esc と後ろで閉じる。
 *   前は {deliveryNote}・{order}・{paymentNotice}の画面が確認の1行を備考の下（画面のいちばん下）に出していて、上の「⋯」から押すと見えなかった。
 *   削除の API を呼ぶのは onConfirm（その画面の移り先・通知も onConfirm の中）。断られたら窓の中に API の文を出す。
 *   testid は `${prefix}-delete-dialog`・`-ask`・`-cancel`・`-confirm`
 */
import { DRAFT_DELETE_MSG as M } from "@genbaryoku/contract";
import { useState } from "react";
import { messageOf } from "../api.js";
import { ErrorText } from "./ui.jsx";

export function DeleteDraftDialog({ prefix, body = M.ask, confirmLabel = M.confirm, onClose, onConfirm }: {
  prefix: string;
  body?: string | undefined;
  confirmLabel?: string | undefined;
  onClose: () => void;
  /** 削除して移る・通知する。投げた誤りは窓の中に出す */
  onConfirm: () => Promise<void>;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const close = () => !busy && onClose();
  const doDelete = async () => {
    setBusy(true);
    setError(undefined);
    try {
      await onConfirm();
    } catch (e) {
      setBusy(false);
      setError(messageOf(e));
    }
  };
  return (
    <div className="dim" onClick={(e) => e.target === e.currentTarget && close()}>
      <div className="dlg" role="alertdialog" aria-label={M.title} data-testid={`${prefix}-delete-dialog`} onKeyDown={(e) => e.key === "Escape" && close()}>
        <div className="dh">{M.title}</div>
        <div className="db">
          <p style={{ margin: 0 }} data-testid={`${prefix}-delete-ask`}>{body}</p>
          <ErrorText>{error}</ErrorText>
        </div>
        <div className="df">
          <button type="button" className="btn primary" autoFocus disabled={busy} onClick={onClose} data-testid={`${prefix}-delete-cancel`}>{M.cancel}</button>
          <button type="button" className="btn shu" disabled={busy} onClick={() => void doDelete()} data-testid={`${prefix}-delete-confirm`}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
